import { Component, Input } from '@angular/core';
import { VisibilityConfig } from '../../../../../atoms/label-with-icon/models/label-with-icon.interfaces';
import { CSSProperties } from './../../../../../../models/styles.interfaces';

/**
 * This component is responsible to create a text container with custom
 * styling and text direction.
 */
@Component({
  selector: 'idp-banner-text',
  templateUrl: './banner-text.component.html',
  styleUrls: ['./banner-text.component.scss']
})
export class BannerTextComponent {
  @Input()
  content!: string;

  @Input() config: VisibilityConfig = {} as VisibilityConfig;
  @Input() styles: CSSProperties = {} as CSSProperties;

  /** prepare text container class according to the position */
  get textContainerClass(): string {
    // eslint-disable-next-line no-extra-boolean-cast
    return !!this.styles.position
      ? 'text-align-' + this.styles.position
      : 'text-align-left';
  }
}
